const createPlainHTMLClassName = customClass => `plainHTML ${customClass} wysiwyg`

export default createPlainHTMLClassName